import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { AuthClient, IAuthContextProps, KeycloakAction, IKeycloakProviderState } from './types';
import { defaultKeycloakProviderState } from './defaultState';

const KeycloakContext = createContext<Partial<IKeycloakProviderState<AuthClient>>>(defaultKeycloakProviderState);
const KeycloakDispatchContext = createContext<Dispatch<KeycloakAction<AuthClient>> | undefined>(undefined);

/**
 * Create a React context containing an AuthClient instance.
 *
 * @param {IAuthContextProps} initialContext initial context value.
 *
 * @returns {React.Context} the ReactKeycloak context.
 */
const createKeycloakContext = (initialContext?: Partial<IAuthContextProps<AuthClient>>) =>
  createContext({
    initialized: false,
    ...initialContext,
  });

export { KeycloakContext, KeycloakDispatchContext, createKeycloakContext };
